import { Box, Button, Card, CardActions, CardContent, Container, Stack, ThemeProvider, Typography } from '@ethings/ui-toolkit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useResponsiveText } from '../../hooks';
import { innerText } from '../../util';
import { Icon } from '../icons';

export const NetworkErrorMessage: FC = () => {
  const { t } = useTranslation();

  const labelText = t('component.network-error.label');
  const labelLength = innerText(labelText).length;
  const h6Styles = useResponsiveText('1.25rem', labelLength, {
    minFontSize: '1rem',
    maxFontSize: '1.25rem',
    textLengthThreshold: 25,
  });

  return <ThemeProvider>
    <Container maxWidth='xs'>
      <Box mt={3}>
        <Card>
          <CardContent>
            <Stack textAlign='center' spacing={1}>
              <Box>
                <Typography
                  variant="h6"
                  style={{
                    fontSize: h6Styles.fontSize,
                    lineHeight: h6Styles.lineHeight,
                    wordBreak: h6Styles.wordBreak,
                    whiteSpace: h6Styles.whiteSpace,
                    overflow: h6Styles.overflow,
                    textOverflow: h6Styles.textOverflow,
                  }}
                >
                  {labelText}
                </Typography>
              </Box>
              <Box><Icon fontSize="large" color="warning" icon="WiFi" /></Box>
              <Box>{t('component.network-error.hint')}</Box>
            </Stack>
          </CardContent>
          <CardActions>
            <Button variant="contained" fullWidth onClick={() => window.location.reload()}>{t('common.action.retry')}</Button>
          </CardActions>
        </Card>
      </Box>
    </Container>
  </ThemeProvider>;
};
